module.exports={account_link_complete_message:"Collegamento account Nexon completato."};